import './App.css';

import {useTranslation} from 'react-i18next';
import useMockEnrolmentState from "./State/useMockEnrolmentState";
import EnrolmentNavigationController from "./DataCollection/EnrolmentNavigationController";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import Header from "./Header/Header";
import {useEffect, useState} from "react";
import LoginForm from "./Authentication/LoginForm";
import RegistrationForm from "./Authentication/RegistrationForm";
import {status} from "./Utils/APIUtils";
import {AuthenticationStatusProvider, useAuthenticationStatus} from "./Authentication/AuthenticationStatusProvider";
import ProtectedComponent from "./Authentication/ProtectedComponent";
import ManageEnrolments from "./ManageEnrolments/ManageEnrolments";
import {HeaderContextProvider} from "./Header/HeaderContextProvider";

const lngs = {
    en: {nativeName: 'English'},
    fr: {nativeName: 'Francais'}
};


function App() {
    return (
        <AuthenticationStatusProvider>
            <HeaderContextProvider>
                <AppContent />
            </HeaderContextProvider>
        </AuthenticationStatusProvider>
    );
}

function AppContent() {
    //   AUTHENTICATION CONTEXT
    const {setAuthenticationStatus} = useAuthenticationStatus();

    useEffect(() => {
        status()
            .then(data => {
                setAuthenticationStatus({
                    isAuthenticated: data.isAuthenticated,
                    user: data.user,
                });
            })
            .catch(error => {
                setAuthenticationStatus({
                    isAuthenticated: false,
                    user: {},
                });
                console.error('Error checking authentication status:', error);
            });
    }, []);

    return (
        <div>
            <Header
                onLogout={() => {
                    window.location = '/login';
                }}
            />
            <div className={'main-body'}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={
                            <ProtectedComponent component={<Dashboard />} />
                        }/>

                        <Route path="/enrolments" element={
                            <ProtectedComponent component={<ManageEnrolments />} />
                        }/>

                        {/*TODO: Enrolments, Enrollments, Enrolments, Enrolments... Enrolment and Enrolments is correct - always use 1 L! */}
                        <Route path="/enrolment/:id?/:subElement?/:item?" element={
                            <ProtectedComponent component={<EnrolmentNavigationController lngs={lngs} />} />
                        }/>
                        <Route path="/enrollment/:id?/:subElement?/:item?" element={
                            <ProtectedComponent component={<EnrolmentNavigationController lngs={lngs} />} />
                        }/>

                        <Route path="/login" element={
                            <LoginForm />
                        }/>

                        <Route path="/register" element={
                            <RegistrationForm />
                        }/>

                    </Routes>
                </BrowserRouter>
            </div>
        </div>
    );
}


export default App;
